<script lang="ts" setup>
import type {PageCollectionItemBase} from "@nuxt/content";
import ProjectDetail from "~/components/project/ProjectDetail.vue";

const {collectionUri} = useI18nCollection();
const {getAllButIndex, getIndex} = usePage();
const pages = await queryCollection(collectionUri('projects')).all();
const index: PageCollectionItemBase = getIndex(pages)!;
const items: PageCollectionItemBase[] = getAllButIndex(pages)!;
const { t } = useI18n();

// SEO optimization
useSeo({
  title: index?.seoTitle || t('seo.projects.title'),
  description: index?.seoDescription || t('seo.projects.description'),
});
</script>

<template>
  <main>
    <SectionPageHeader :page="index" :show-body-mobile="true" class="mb-8"/>
    <section class="page-container">
      <ProjectDetail
              v-for="(item, index) in items"
              :key="item.path"
              :class="{
                  'bg-brand/10 tablet:flex-row-reverse tablet:me-[20vw]': index % 2 === 0,
                  'bg-tertiary/10  tablet:ms-[20vw]': index % 2 !== 0
              }"
              :item="item"
              class="rounded-img mb-12 p-6"
      />
    </section>
  </main>
</template>

<style scoped>

</style>